import Axios from 'src/utils/axiosConfig';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const filterLoans = createAsyncThunk('loans/all', async (payload, { rejectWithValue }) => {
  try {
    const { pageSize, page, userId } = payload;

    const queryParams = `?page=${page}&pageSize=${pageSize}`;
    const bodyData = { userId };

    if (payload.loanTypeId) {
      bodyData.loanTypeId = payload.loanTypeId;
    }

    const result = await Axios.post(`admin/loans/all${queryParams}`, bodyData);

    return result.data;
  } catch (error) {
    if (error.response) {
      return rejectWithValue(error.response.data);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});
